export const getSocketsUrl = () => {
  return import.meta.env.VITE_SOCKETS
}
